import { createTheme } from "@mui/material/styles";
import baseTheme from "assets/theme";

const g = baseTheme.palette.gradients;

const PALETTES = {
  navy: {},  // original — no overrides

  cream: {
    palette: {
      info:  { main: "#C9954C", focus: "#E0B06A" },
      brand: { main: "#C9954C", focus: "#E0B06A" },
      gradients: { ...g,
        cover: { deg:"159.02", main:"#2A1E0A 14.25%", state:"#1A1204 56.45%", stateSecondary:"#100C02 86.14%" },
        info:  { main:"#C9954C", state:"#E0B06A" },
      },
    },
  },

  white: {
    palette: {
      info:  { main: "#0071E3", focus: "#2997FF" },
      brand: { main: "#0071E3", focus: "#2997FF" },
      gradients: { ...g,
        cover: { deg:"159.02", main:"#F5F5F7 14.25%", state:"#E8E8ED 56.45%", stateSecondary:"#D8D8DC 86.14%" },
        info:  { main:"#0071E3", state:"#2997FF" },
      },
      text: { main: "#1D1D1F", focus: "#1D1D1F" },
      dark: { ...baseTheme.palette.dark, body: "#F5F5F7" },
    },
  },
};

export const BG = {
  navy:  "linear-gradient(159.02deg, #0f123b 14.25%, #090d2e 56.45%, #020515 86.14%)",
  cream: "linear-gradient(159.02deg, #2A1E0A 14.25%, #1A1204 56.45%, #100C02 86.14%)",
  white: "linear-gradient(159.02deg, #F5F5F7 14.25%, #E8E8ED 56.45%, #D8D8DC 86.14%)",
};

export const THEME_LIST = [
  { key: "navy",  label: "Navy Blue",   color: "#0075ff" },
  { key: "cream", label: "Cream",       color: "#C9954C" },
  { key: "white", label: "Apple White", color: "#E8E8ED", border: "#999" },
];

export default function buildTheme(name) {
  return createTheme(baseTheme, PALETTES[name] || {});
}
